import React, { useContext } from 'react';
import clsx from 'clsx';
import classes from './HeaderColumn.module.scss';
import { SortButton } from './SortButton/SortButton';
import { SelectAllButton } from '../SelectAllButton';
import FilterButton from './FilterButton/FilterButton';
import { WMTableColumnShape } from '../../WMTable/WMTable';
import { AppTableContext } from '../../AppTableContext';

const HeaderColumn = ({
    column,
    data,
    disabled,
    isSomeChecked,
    isAllChecked,
    sorting,
    onSortingChange,
    isColumnFilterActive,
    setEditFilter,
    isFilterBoxOpen,
    columnIndex
}: {
    column: WMTableColumnShape;
    data: $TSFixMe;
    disabled: boolean;
    isSomeChecked: $TSFixMe;
    isAllChecked: $TSFixMe;
    sorting: $TSFixMe;
    onSortingChange?: $TSFixMe;
    isColumnFilterActive?: (column: WMTableColumnShape) => boolean;
    setEditFilter?: $TSFixMe;
    isFilterBoxOpen: boolean;
    columnIndex: number;
}) => {
    const flexGrow = typeof column.flexGrow === 'number' ? column.flexGrow : 0;
    const flexShrink = typeof column.flexShrink === 'number' ? column.flexShrink : 1;
    const flexValue = `${flexGrow} ${flexShrink} auto`;
    const isActiveSort = sorting.dataKey === column.dataKey;

    const handleSorting = () => {
        if (!disabled && column.sortable) {
            onSortingChange?.({
                dataKey: column.dataKey,
                direction: isActiveSort ? (sorting.direction === 'desc' ? 'asc' : 'desc') : 'desc'
            });
        }
    };

    const { tableDataTestid } = useContext(AppTableContext);

    return (
        <div
            onClick={handleSorting}
            className={clsx(classes.column, column.className, {
                [classes.columnVisibleFilter]: isFilterBoxOpen || isColumnFilterActive?.(column),
                [classes.columnVisibleSort]: isActiveSort
            })}
            style={{
                flex: flexValue,
                width: column.width,
                justifyContent: column.dataKey === 'engagement' ? 'center' : 'flex-start',
                minWidth: column.minWidth,
                maxWidth: column.maxWidth
            }}
        >
            <span className={classes.checkboxWrapper} data-testid={`${tableDataTestid}-header-title-${columnIndex}`}>
                {column.dataKey === 'checked' ? (
                    <SelectAllButton data={data} isSomeSelected={isSomeChecked} isAllSelected={isAllChecked} disabled={disabled} />
                ) : (
                    <span>{column.title}</span>
                )}
            </span>
            {!disabled && (
                <>
                    {!disabled && (
                        <div className={classes.actionsArea}>
                            {column?.sortable && (
                                <div className={classes.sortArea}>
                                    <SortButton sorting={sorting} columnDataKey={column.dataKey} isActiveSort={isActiveSort} />
                                </div>
                            )}

                            {column?.filterMetaData?.active && (
                                <div className={classes.filterArea}>
                                    <FilterButton
                                        isColumnFilterActive={isColumnFilterActive}
                                        column={column}
                                        setEditFilter={setEditFilter}
                                        isFilterBoxOpen={isFilterBoxOpen}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default HeaderColumn;
